import { ATTRIBUTE_LABELS } from '../../data/mockVtubers';
import StreamHeatmap, { DAY_LABELS, DAY_ORDER } from './StreamHeatmap';

const boxStyle = {
  background: '#fff',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
};

const styles = {
  trendRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    alignItems: 'stretch',
  },
  trendCol: {
    ...boxStyle,
    flex: '1 1 260px',
    minWidth: '260px',
  },
};

function StreamTrends({ vtuber }) {
  return (
    <div style={styles.trendRow}>
      <section style={styles.trendCol}>
        <h3>配信時間帯ヒートマップ</h3>
        <StreamHeatmap heatmap={vtuber.stream_heatmap} />
      </section>
    </div>
  );
}

export default StreamTrends;
